module.exports = __webpack_public_path__ + "img/teacher2.0fb4633c.png";